<template>
  <div>
    <div id="billingMethods">
      <h1>Manage Billing Methods</h1>
      <span v-if="!billingMethods.length">No Billing Methods</span>
      <div class="billingMethods">
        <div
          v-for="entry in billingMethods"
          :key="entry.id"
          class="billingMethod"
        >
          {{ entry.payment_method }}<br />
          ********{{ entry.payment_last_4 }}<br />
          Exp: {{ entry.payment_exp_date }}
        </div>
      </div>
      <div class="center-text">
        <router-link
          to="/console/account/billing/create"
          tag="button"
          name="addProperty"
          class="button button-300"
          >Create Billing Method</router-link
        >
      </div>
      <v-dialog />
    </div>
  </div>
</template>
<script>
import api from "@/api/index";
const apiServiceBilling = new api.APIServiceBilling();

export default {
  name: "AccountBilling",
  data() {
    return {
      billingMethods: []
    };
  },
  created() {
    this.getAccountBillingMethods();
  },
  methods: {
    getAccountBillingMethods: function() {
      apiServiceBilling.getAccountBillingMethods().then(data => {
        if (data) {
          this.billingMethods = data.data;
        }
      });
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 24px;
}
h2 {
  font-size: 18px;
}
h3 {
  font-size: 18px;
  margin-bottom: 0;
}
#billingMethods {
  lost-utility: clearfix;
}
.billingMethods {
  width: 100%;
  lost-column: 1/1;
}
.billingMethod {
  lost-column: 1/3;
  background: #d5e3f4;
  padding: 15px;
  border-radius: 4px;
  lost-utility: clearfix;
  margin-bottom: 20px;
}
.addMethodContainer {
  margin-top: 15px;
}
@media (max-width: 800px) {
  .billingMethod {
    lost-column: 1/2;
  }
}
@media (max-width: 640px) {
  .billingMethod {
    lost-column: 1/1;
  }
}
</style>
